import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Paper, Typography, Button, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import PersonIcon from '@material-ui/icons/Person';
import BusinessIcon from '@material-ui/icons/Business';
import HomeWorkIcon from '@material-ui/icons/HomeWork';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            margin: "15px",
            textAlign: "left",
            paddingBottom: theme.spacing(4),
            marginBottom: theme.spacing(3)
        },
        headerBar: {
            backgroundColor: "#0404fc",
            borderWidth: "5px",
            height: "29px",
            marginRight: "17px",
            marginLeft: "17px",
        },
        description: {
            margin: theme.spacing(2),
            textAlign: 'center'
        },
        userTypesContainer: {
            padding: theme.spacing(2),
            paddingTop: theme.spacing(1)
        },
        userCard: {
            padding: theme.spacing(2),
            margin: theme.spacing(1),
            textAlign: 'center',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
        titleSpacing: {
            marginBottom: theme.spacing(1)
        },
        icon: {
            fontSize: '4rem',
            color: '#0404fc',
            marginBottom: theme.spacing(2)
        },
        chooseButton: {
            backgroundColor: "#17d703",
            color: "white",
            marginTop: theme.spacing(1),
            '&:hover': {
                backgroundColor: "#15c003"
            }
        },
        roleContainer: {
            marginBottom: theme.spacing(2)
        },
        roleTitle: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: theme.palette.primary.main
        },
        roleDetail: {
            color: theme.palette.text.secondary,
            fontSize: '0.9rem',
            marginBottom: theme.spacing(1)
        }
    })
);

const userTypes = [
    {
        title: 'Tenant',
        detail: 'Search retail properties and review scores',
        description: 'Access full due-diligence Property Reports',
        icon: <PersonIcon />,
        path: '/signup/tenant'
    },
    {
        title: 'Landlord',
        detail: 'Claim and manage your properties',
        description: 'Verify property information and boost your Parslii Scores',
        icon: <HomeWorkIcon />,
        path: '/signup/landlord/subscriptions'
    },
    {
        title: 'Broker',
        detail: 'Manage the properties you list',
        description: 'Access Parslii research to provide to potential tenants and expedite the leasing process',
        icon: <BusinessIcon />,
        path: '/signup/broker'
    }
];

export default function SignUpAs() {
    const classes = useStyles();
    const history = useHistory();

    const handleChooseType = (path: string) => {
        history.push(path);
    };

    return (
        <div>
            <div className={classes.headerBar} />
            <Paper className={classes.root}>
                <div className={classes.description}>
                    <Typography variant="h4" className={classes.titleSpacing}>
                        Choose Your Role
                    </Typography>
                    <Typography variant="body1" paragraph style={{ marginBottom: 8 }}>
                        Select the account type that best matches your needs. Each role provides
                        specific features and capabilities designed for your use case.
                    </Typography>
                </div>

                <Typography variant="h4" align="center" style={{ marginBottom: 16 }}>
                    Available Account Types
                </Typography>

                <Grid container className={classes.userTypesContainer}>
                    {userTypes.map((type, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <Paper elevation={3} className={classes.userCard}>
                                <div>
                                    <div className={classes.icon}>
                                        {type.icon}
                                    </div>
                                    <div className={classes.roleContainer}>
                                        <Typography className={classes.roleTitle}>
                                            {type.title}
                                        </Typography>
                                        <Typography className={classes.roleDetail}>
                                            {type.detail}
                                        </Typography>
                                    </div>
                                    <Typography variant="body1">
                                        {type.description}
                                    </Typography>
                                </div>
                                <Button
                                    variant="contained"
                                    className={classes.chooseButton}
                                    fullWidth
                                    onClick={() => handleChooseType(type.path)}
                                >
                                    Choose {type.title}
                                </Button>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </div>
    );
}